import React, { useState, useEffect } from 'react'
import { Box, Anchor, Text, Button } from "grommet"
import TTJsonTree from '../../../common/TTJsonTree'
import { useGetTaskResults } from './TriageHistoryAPI'
import TriageFile from '../../TriageFile'
import { TopBarFile } from '../../TriageViewUtils'
import { SpinnerOverlayAthena } from '../../../common/SpinnerOverlay'
import { Warn } from '../../../common/Warn'

const TriageHistoryViewResult = ({ content }) => {

    const [triageFiles, setTriageFiles] = useState([])
    const [triageResult, setTriageResult] = useState({})

    const { urlResponse: taskResults, isLoading } = useGetTaskResults(content.taskid)

    useEffect(() => {
        if (taskResults && taskResults.files && taskResults.results) {
            setTriageResult(taskResults.results)
            setTriageFiles(taskResults.files)
        }

    }, [taskResults])

    const urlLink = '/triage/triagetask/' + content.taskid

    return (
        <>
            <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }} gap="small">

                <Box direction="row" gap="small">

                    <Box>
                        <Text weight='bold'>Triage Response</Text>
                    </Box>

                    <Box
                        pad="none"
                        gap="none"
                        margin={{ left: "10px" }}
                        background="brand"
                        round="xsmall"
                        height="25px"
                    >
                        <Anchor margin={{ left: "6px", right: "6px" }} href={urlLink} target="_blank">
                            <Button plain label={<Text color="white" size="12px" weight="normal">Sharable Link</Text>} margin={{ top: "xxsmall" }} hoverIndicator={{ color: "light-1", opacity: "weak" }} />
                        </Anchor>
                    </Box>

                    <Box
                        pad="none"
                        gap="none"
                        height="25px"
                        margin={{ left: "5px" }}
                        align="center"
                    >

                    </Box>
                </Box>

                <Box margin={{ top: "small" }}>
                </Box>

                <Box height="80%">
                    {
                        triageResult && <TTJsonTree data={triageResult} expandAll={true} />
                    }

                    {isLoading &&
                        <SpinnerOverlayAthena />
                    }

                    {triageFiles && triageFiles.length > 0 && !isLoading &&
                        //  IF MANUAL and Status is Completed AND Have Files -> Get Result from API
                        triageFiles.map(resultFile => (
                            <>
                                <TopBarFile triageFileUrl={resultFile} />
                                <TriageFile key={resultFile} triageFileUrl={resultFile} />
                            </>
                        ))
                    }

                    {triageFiles && triageFiles.length === 0 && triageResult && Object.keys(triageResult).length === 0 && !isLoading &&
                        <Warn warning="No Results" subWarning={"From Triage Task"} />
                    }

                </Box>
            </Box>
        </>
    )
}

export default TriageHistoryViewResult